export const config = {
  host: 'https://dev.adroady.com',
};

export default config;
